<template>
  <div class="conversion-card-container">
    <div class="conversion-card">
      <div class="conversion-icon-area">
        <i class="el-icon-key"></i>
      </div>
      <div class="conversion-title">高校电子卡绑定</div>
      <div
        class="conversion-desc"
        v-if="!hasAnyModulePermission"
      >
        请输入高校专属电子卡卡密，绑定后可享受高校会员权益。
      </div>
      <div class="conversion-desc" v-else>
        您已绑定电子卡，可享受以下模块服务：
        <div class="module-list">
          <el-tag 
            v-for="module in userModules" 
            :key="module.moduleMark"
            :type="module.isExpired ? 'danger' : 'success'"
            size="small"
            class="module-tag"
          >
            {{ module.moduleName }}
            <span v-if="module.isExpired" class="expired-text">(已过期)</span>
          </el-tag>
        </div>
      </div>
      <div
        class="conversion-form-area"
        v-show="!hasAnyModulePermission"
      >
        <el-input
          v-model="password"
          placeholder="请输入高校电子卡卡密"
          @focus="focus"
          @input="onPasswordInput"
          size="medium"
          maxlength="24"
          class="conversion-input"
        />
        <div class="conversion-alert-fixed">
          <el-alert
            :title="alertMsg"
            :type="alertType"
            show-icon
            class="conversion-alert"
            :closable="false"
            :style="{
              visibility: alertMsg ? 'visible' : 'hidden',
              opacity: alertMsg ? 1 : 0,
              minHeight: '40px'
            }"
          />
        </div>
        <el-button
          type="primary"
          @click="exchange()"
          size="medium"
          style="width:100%;margin-top:8px;"
          >绑定</el-button
        >
      </div>
      <div
        class="conversion-form-area"
        v-show="hasAnyModulePermission"
      >
        <div class="module-details">
          <div 
            v-for="module in userModules" 
            :key="module.moduleMark"
            class="module-detail-item"
          >
            <div class="module-header">
              <h3 class="module-title">{{ module.moduleName }}</h3>
              <el-tag 
                :type="module.isExpired ? 'danger' : 'success'"
                size="small"
                class="status-tag"
              >
                {{ module.isExpired ? '已过期' : '有效' }}
              </el-tag>
            </div>
            <div class="module-content">
              <div class="module-info-row">
                <span class="info-label">电子卡名称：</span>
                <span class="info-value">{{ module.ecardName }}</span>
              </div>
              <div class="module-info-row">
                <span class="info-label">到期时间：</span>
                <span class="info-value expire-time">{{ formatDate(module.expireTime) }}</span>
              </div>
              <div class="module-info-row" v-if="module.schoolName">
                <span class="info-label">所属学校：</span>
                <span class="info-value">{{ module.schoolName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showConfirmCard" class="confirm-card-mask">
        <div class="confirm-card">
          <div class="confirm-title">请确认电子卡信息</div>
          <div class="confirm-info-row">
            <span>电子卡名称：</span><b>{{ confirmCardName }}</b>
          </div>
          <div class="confirm-info-row">
            <span>到期时间：</span><b>{{ formatDate(confirmCardDate) }}</b>
          </div>
          <div class="confirm-btns">
            <el-button @click="cancelConfirm" size="medium">取消</el-button>
            <el-button type="primary" @click="doBind" size="medium"
              >确认绑定</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';

export default {
  data() {
    return {
      password: "",
      ruleForm: {
        vipName: "",
        vipDate: ""
      },
      alertMsg: "",
      alertType: "success",
      showConfirmCard: false,
      confirmCardName: "",
      confirmCardDate: "",
      confirmCardPwd: "",
      // 新增：用户模块权限相关数据
      userModules: [],
      hasAnyModulePermission: false,
      modulePermissions: {},
      moduleDefinitions: {}
    };
  },
  methods: {
    // 获取用户模块权限信息
    async getUserModulePermissions() {
      if (!this.$store.state.token) {
        this.hasAnyModulePermission = false;
        this.userModules = [];
        return;
      }

      try {
        const response = await api.getUserEcardModulePermissions(this.$store.state.token);
        
        if (response.data.code === 200) {
          const data = response.data.data;
          this.modulePermissions = data.modulePermissions || {};
          this.moduleDefinitions = data.moduleDefinitions || {};
          
          // 处理用户模块数据
          this.userModules = [];
          Object.keys(this.modulePermissions).forEach(moduleMark => {
            const permission = this.modulePermissions[moduleMark];
            const moduleName = this.moduleDefinitions[moduleMark] || `模块${moduleMark}`;
            
            this.userModules.push({
              moduleMark: parseInt(moduleMark),
              moduleName: moduleName,
              ecardName: permission.ecardName || '',
              expireTime: permission.expireTime || '',
              createTime: permission.createTime || '',
              isExpired: permission.isExpired || false,
              isActive: permission.isActive || 0,
              hasPermission: permission.hasPermission || false,
              schoolName: permission.schoolName || ''
            });
          });
          
          this.hasAnyModulePermission = this.userModules.length > 0;
        } else {
          this.hasAnyModulePermission = false;
          this.userModules = [];
        }
      } catch (error) {
        console.error('获取模块权限失败:', error);
        this.hasAnyModulePermission = false;
        this.userModules = [];
      }
    },

    getapp() {
      // 兼容旧逻辑，但主要依赖新的模块权限检查
      if (this.$store.state.vip) {
        this.ruleForm.vipName = this.$store.state.vipName;
        this.ruleForm.vipDate = this.$store.state.vipDate;
      }
    },
    focus() {
      this.alertMsg = "";
    },
    onPasswordInput() {
      // 实时清除错误信息
      if (this.alertType === "error") {
        this.alertMsg = "";
      }
    },
    exchange() {
      // 清除之前的错误信息
      this.alertMsg = "";
      
      // 验证输入
      if (!this.password) {
        this.alertMsg = "请输入高校电子卡卡密";
        this.alertType = "error";
        return;
      }
      
      if (this.password.length < 6) {
        this.alertMsg = "卡密长度不能少于6位";
        this.alertType = "error";
        return;
      }
      
      // 显示加载状态
      this.alertMsg = "正在验证卡密，请稍候...";
      this.alertType = "info";
      
      // 优先使用通用电子卡查询接口（支持所有模块类型）
      this.axios
        .myecardquery({
          token: this.$store.state.token,
          password: this.password
        })
        .then(res => {
          if (res.data.code == 200) {
            this.alertMsg = "卡密校验成功，请点击下方按钮完成绑定";
            this.alertType = "success";
            this.confirmCardName = res.data.data.name;
            this.confirmCardDate = res.data.data.endDate;
            this.confirmCardPwd = this.password;
            this.showConfirmCard = true;
          } else {
            this.alertMsg = res.data.message || "卡密验证失败";
            this.alertType = "error";
          }
        })
        .catch(err => {
          console.error('卡密验证错误:', err);
          if (err.response) {
            // 服务器响应错误
            this.alertMsg = err.response.data?.message || "服务器错误，请稍后重试";
          } else if (err.request) {
            // 网络错误
            this.alertMsg = "网络连接失败，请检查网络后重试";
          } else {
            // 其他错误
            this.alertMsg = "验证失败，请稍后重试";
          }
          this.alertType = "error";
        });
    },
    cancelConfirm() {
      this.showConfirmCard = false;
    },
    doBind() {
      this.showConfirmCard = false;
      
      // 显示绑定进度
      this.alertMsg = "正在绑定卡密，请稍候...";
      this.alertType = "info";
      
      // 使用通用电子卡绑定接口（支持所有模块类型）
      this.axios
        .myecardbind({
          token: this.$store.state.token,
          password: this.confirmCardPwd
        })
        .then(res => {
          if (res.data.code == 200) {
            this.alertMsg = "绑定成功！您已成为高校会员。";
            this.alertType = "success";
            
            // 更新store状态
            this.$store.dispatch("vip", res.data.data.vip);
            this.$store.dispatch("vipName", res.data.data.vipName);
            this.$store.dispatch("vipDate", res.data.data.vipDate);
            
            // 更新本地显示
            this.ruleForm.vipName = res.data.data.vipName;
            this.ruleForm.vipDate = res.data.data.vipDate;
            
            // 清空密码输入
            this.password = "";
            
            // 重新获取用户模块权限信息
            this.getUserModulePermissions();
            
            // 延迟刷新页面以显示更新后的状态
            setTimeout(() => {
              this.$forceUpdate(); // 强制更新组件
            }, 1500);
          } else {
            this.alertMsg = res.data.message || "绑定失败";
            this.alertType = "error";
          }
        })
        .catch(err => {
          console.error('卡密绑定错误:', err);
          if (err.response) {
            this.alertMsg = err.response.data?.message || "服务器错误，请稍后重试";
          } else if (err.request) {
            this.alertMsg = "网络连接失败，请检查网络后重试";
          } else {
            this.alertMsg = "绑定失败，请稍后重试";
          }
          this.alertType = "error";
        });
    },
    formatDate(val) {
      if (!val) return "";
      return val.toString().slice(0, 10);
    }
  },
  mounted() {
    this.getapp();
    this.getUserModulePermissions();
  }
};
</script>
<style scoped>
.conversion-card-container {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
}
.conversion-card {
  width: 550px;
  max-width: 90vw;
  margin-top: 60px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 48px 48px 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  transition: width 0.2s, padding 0.2s;
}
.conversion-icon-area {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1787f 0%, #f7b267 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 40px;
  margin-bottom: 22px;
  box-shadow: 0 2px 8px rgba(241, 120, 127, 0.1);
}
.conversion-title {
  font-size: 26px;
  font-weight: 700;
  color: #f1787f;
  margin-bottom: 12px;
}
.conversion-desc {
  color: #888;
  font-size: 17px;
  margin-bottom: 22px;
  text-align: center;
}
.conversion-form-area {
  width: 100%;
  margin-top: 12px;
}
.conversion-input {
  width: 320px !important;
  max-width: 90%;
  margin: 0 auto 0 auto;
  display: block;
}
.conversion-alert-fixed {
  min-height: 32px; /* 原40px，减小高度 */
  margin: 6px 0 0 0; /* 原14px，减小上边距 */
  width: 100%;
}
.conversion-alert {
  width: 100%;
  margin: 0 auto;
  transition: opacity 0.2s;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
/* 绑定按钮的上边距 */
.conversion-form-area > .el-button[type="primary"] {
  margin-top: 8px !important; /* 原18px，缩小 */
}
.conversion-date-input {
  color: #f1787f !important;
  font-weight: 600;
  letter-spacing: 1px;
}
.confirm-card-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.12);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.13);
  padding: 32px 32px 24px 32px;
  min-width: 320px;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeInCard 0.2s;
}
.confirm-title {
  color: #f1787f;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 18px;
}
.confirm-info-row {
  font-size: 15px;
  color: #444;
  margin-bottom: 8px;
  width: 100%;
  text-align: left;
}
.confirm-info-row b {
  font-weight: 700;
  color: #f1787f;
  margin-left: 8px;
  letter-spacing: 1px;
}
.confirm-btns {
  display: flex;
  gap: 18px;
  margin-top: 18px;
  width: 100%;
  justify-content: center;
}
@keyframes fadeInCard {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 模块相关样式 */
.module-list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.module-tag {
  margin: 2px;
}

.expired-text {
  color: #f56c6c;
  font-size: 12px;
}

.module-details {
  width: 100%;
}

.module-detail-item {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.module-detail-item:hover {
  background: #fff;
  border-color: #f1787f;
  box-shadow: 0 4px 16px rgba(241, 120, 127, 0.15);
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f8f9fa;
}

.module-title {
  font-size: 20px;
  font-weight: 700;
  color: #f1787f;
  margin: 0;
  letter-spacing: 0.5px;
}

.status-tag {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 5px;
  line-height: 1;
}

.module-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.module-info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  min-width: 80px;
  margin-right: 8px;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  flex: 1;
}

.info-value.expire-time {
  color: #f1787f;
  font-weight: 700;
}
@media (max-width: 900px) {
  .conversion-card {
    width: 98vw;
    padding: 16px 2vw 16px 2vw;
  }
  .conversion-input {
    width: 98vw !important;
    max-width: 98vw;
  }
  .confirm-card {
    min-width: 90vw;
    padding: 16px 2vw 16px 2vw;
  }
  
  .module-detail-item {
    padding: 16px;
    margin-bottom: 12px;
  }
  
  .module-title {
    font-size: 18px;
  }
  
  .module-header {
    margin-bottom: 12px;
    padding-bottom: 8px;
  }
  
  .module-content {
    gap: 8px;
  }
  
  .module-info-row {
    padding: 6px 0;
  }
  
  .info-label {
    font-size: 13px;
    min-width: 70px;
  }
  
  .info-value {
    font-size: 13px;
  }
}
</style>
